/**
 * Civil Nexus - Date & Time Engine
 * ذخیره همواره به صورت Timestamp عددی و نمایش از طریق استاندارد تقویم جلالی
 */

export const dateUtils = {
  now: () => Date.now(),

  formatJalali: (timestamp) => {
    if (!timestamp) return '---';
    try {
      return new Intl.DateTimeFormat('fa-IR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }).format(new Date(timestamp));
    } catch (e) {
      return new Date(timestamp).toLocaleDateString('fa-IR');
    }
  },

  formatJalaliWithTime: (timestamp) => {
    if (!timestamp) return '---';
    try {
      return new Intl.DateTimeFormat('fa-IR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      }).format(new Date(timestamp));
    } catch (e) {
      return new Date(timestamp).toLocaleString('fa-IR');
    }
  }
};
